import { render, staticRenderFns } from "./form-ix.vue?vue&type=template&id=25d49146"
import script from "./form-ix.vue?vue&type=script&lang=js"
export * from "./form-ix.vue?vue&type=script&lang=js"
import style0 from "../../assets/site.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports